export const SalesChannels = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9 16H23" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<path d="M23 26H17C16.4477 26 16 25.5523 16 25V7C16 6.44772 16.4477 6 17 6H23" stroke="currentColor" stroke-width="2" stroke-linejoin="round"/>
<circle cx="26" cy="6" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="26" cy="16" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="6" cy="16" r="3" stroke="currentColor" stroke-width="2"/>
<circle cx="26" cy="26" r="3" stroke="currentColor" stroke-width="2"/>
</svg>`;
